exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._28YaY39APgvfSozh4lQlbx{display:flex;flex-flow:column nowrap}._1Q9sGZoTHTOyH7Y09pNk7a{color:#bdbdbd;cursor:pointer}._28YaY39APgvfSozh4lQlbx>a,span._1Q9sGZoTHTOyH7Y09pNk7a{font-weight:500;display:flex;align-items:center;padding-top:15px}._28YaY39APgvfSozh4lQlbx>a:first-child,span._1Q9sGZoTHTOyH7Y09pNk7a:first-child{padding-top:0px}._28YaY39APgvfSozh4lQlbx>a img,span._1Q9sGZoTHTOyH7Y09pNk7a img{padding-right:15px}\n", ""]);

// Exports
exports.locals = {
	"links": "_28YaY39APgvfSozh4lQlbx",
	"disabledLink": "_1Q9sGZoTHTOyH7Y09pNk7a"
};